import api from '../../api/mas-athena';

const state = {
    currency: [],
    tax: []
};

const getters = {
    currencyDetails: state => state.currency,
    taxDetails: state => state.tax
};

const actions = {
    async getRates({ commit }) {
        const response = await api.getRates()
        
        commit('setCurrencyDetails', await response.data.results);
    },
    async getTax({ commit }) {
        const response = await api.getTax();
        
        commit('setTax', await response.data.results);
    }   
};

const mutations = {
    setCurrencyDetails: (state, currency) => {
        state.currency = currency
    },
    setTax: (state, tax) => {
        state.tax = tax
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
